/**
 * Aviso en el Dashboard del administrador cuando Verifactu tiene avisos abiertos sin leer
 * (cadena parada, certificado, registros rechazados…). Solo se pide a la API si el usuario es
 * ADMIN y Verifactu está habilitado; si falla, no se enseña nada.
 */
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { api } from '../../lib/api'
import { useAuth } from '../../contexts/AuthContext'
import { useVerifactuConfig } from '../../lib/verifactu'

interface AlertRow {
  id: string
  title: string
  body: string
}

export default function VerifactuAlertsBanner() {
  const auth = useAuth()
  const vf = useVerifactuConfig()
  const isAdmin = auth.status === 'authenticated' && auth.user.role === 'ADMIN'
  const [items, setItems] = useState<AlertRow[]>([])

  useEffect(() => {
    if (!isAdmin || vf?.enabled !== true) return
    api
      .get<{ items: AlertRow[] }>('/verifactu/alerts')
      .then((r) => setItems(r.items))
      .catch(() => setItems([]))
  }, [isAdmin, vf?.enabled])

  if (items.length === 0) return null
  return (
    <Link
      to="/settings/verifactu"
      className="surface p-3 rounded-lg border border-amber-500/30 bg-amber-500/10 text-amber-200 flex items-start gap-2 text-sm hover:bg-amber-500/15"
    >
      <AlertTriangle size={16} className="shrink-0 mt-0.5" />
      <span>
        <strong>
          Verifactu: {items.length === 1 ? '1 aviso' : `${items.length} avisos`} sin leer.
        </strong>{' '}
        {items[0]!.title}
        {items.length > 1 ? ' y más…' : ''}
      </span>
    </Link>
  )
}
